import styles from "./TaxRate.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";

import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
const data = [
  {
    _id: "1",
    name: "New Joining",
    itemCode: "qwert",
    taxRate: "20%",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "2",
    name: "New Joining",
    itemCode: "qwert",
    taxRate: "20%",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "3",
    name: "New Joining",
    itemCode: "qwert",
    taxRate: "20%",
    actions: ["Edit", "Delete"],
  },
];
  

function TaxRate() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);

      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        name: (
          <LogoWithName
            name={item.name}
            subLabel={`Item Code :${item.itemCode}`}
            hideLogo={true}
          />
        ),
        taxRate: item.taxRate,
        action: (
          <Action
            options={item.actions}
            onSelect={(opt) => {
              if (opt === "Edit") dispatch(openModal("editTax"));
              if (opt === "Delete") dispatch(openModal("deleteTax"));
            }}
          />
        ),
      };
    });
  };
  

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? data.map((d) => d._id) : []);
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Name", accessor: "name" },
    { title: "Tax rate", accessor: "taxRate" },
    { title: "Actions", accessor: "action" },
  ];
  

  return (
    <div className={styles.headerContainer}>
      <div className={styles.totalstudentcard}>
        <div className={styles.studentsection}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search name"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          
        </div>

        <div className={styles.dynamicdata}>
          <Dynamic
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>
        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default TaxRate;
